import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=703ffa6c&scoped=true&"
import script from "./listInfo.vue?vue&type=script&lang=babel&"
export * from "./listInfo.vue?vue&type=script&lang=babel&"
import style0 from "./listInfo.vue?vue&type=style&index=0&id=703ffa6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ffa6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VToolbar})
